module.exports = __webpack_public_path__ + "static/media/home-time.b15baa14.svg";